// Using 'as const' with object literals instead of enums
export const Role = {
  Client: 'client',
  ClientManager: 'client_manager',
  ClientApprover: 'client_approver',
  Agent: 'agent',
  Manager: 'manager',
  Admin: 'admin',
} as const

export const RoleGroup = {
  Customer: 'customer',
  Agent: 'agent',
} as const
// Type-safe mapping between Role and RoleGroup
export const RoleGroupMapping: Record<(typeof Role)[keyof typeof Role], RoleGroup> = {
  [Role.Client]: RoleGroup.Customer,
  [Role.ClientManager]: RoleGroup.Customer,
  [Role.ClientApprover]: RoleGroup.Customer,
  [Role.Agent]: RoleGroup.Agent,
  [Role.Manager]: RoleGroup.Agent,
  [Role.Admin]: RoleGroup.Agent,
}
